import React, { useState, useRef, useEffect } from "react";
import { BsSunFill, BsMoonStars } from "react-icons/bs";
import { useSelector } from "react-redux";
import useDarkMode from "../../hook/useDarkMode";
import acwdLogo from "../../assets/Acwdlogo-Hi-Res_png.png";
import hubLogo from "../../assets/WaterSavingsHub_logo.png";

const Header = ({ props }) => {
  // const user = useSelector((state) => state.user.value);
  const [colorTheme, setTheme] = useDarkMode();

  const [loginController, setLoginController] = useState({
    dropdown: false,
    openDropdown: () => {
      setLoginController((prev) => ({
        ...prev,
        dropdown: true,
      }));
    },
    closeDropdown: () => {
      setLoginController((prev) => ({
        ...prev,
        dropdown: false,
      }));
    },
  });

  const [loginDrop, setLoginDrop] = useState(false);
  const openLoginDrop = () => {
    setLoginDrop(true);
  };
  const closeLoginDrop = () => {
    setLoginDrop(false);
  };

  return (
    <div className="w-full top-0 fixed bg-[#7d7d7d] h-[3rem] shadow flex items-center z-50">
      <div className="mr-auto flex p-10 gap-4  text-white font-medium ">
        {/*<span className="text-blue-300">ACWD</span>
        <span className="">WATER CONSERVATION PORTAL</span>*/}
        {/* <img src={acwdLogo} alt="ACWD Logo" className="h-12 align-middle" />
        <img
          src={hubLogo}
          alt="Water Savings Center"
          className="h-14 align-middle"
        /> */}
        {/* <span>{user.firstName}</span> */}
      </div>
      {/* <div className="ml-auto flex p-20 gap-4  text-white font-medium "> */}
      <ul className="flex gap-4 mr-20 items-center">
        {/* <li>
          <span className=" px-2 cursor-pointer hover:bg-wc-blue text-white">
            Login
          </span>
          <span className="text-white">
            {props.loginController.loginType === "ADMIN" ? "Admin" : "Customer"}
          </span>
        </li> */}
        {/* <li>
          <select
            className=" text-white bg-[#7d7d7d] focus:outline-none appearance-none cursor-pointer"
            onChange={(e) => {
              setField((prev) => ({
                ...prev,
                fieldType: e.target.value,
              }));
            }}
            onClick={() => {
              loginController.openDropdown();
            }}
          >
            <option disabled selected className="hidden">
              Sign Up
            </option>

            <option value="CUSTOMER">{`${
              loginController.dropdown ? "CUSTOMER" : "LOGIN"
            }`}</option>
            <option value="ADMIN">ADMIN</option>
          </select>
        </li> */}

        <li>
          <span className="border border-white rounded-xl px-2 cursor-pointer hover:bg-wc-blue text-white">
            www.acwd.org
          </span>
        </li>
      </ul>
      {/* </div> */}
    </div>
  );
};

export default Header;
